import { Detail } from "./detail/detail"

export class Template{
    id : number = 0;
    name : string = "デザインなし" //テンプレート名
    fileName : string = "" //lcxの名前
    thumbnail : string = "" //テンプレートのサムネイル
    productCode : string = "" //作成した品番
    width : number = 0 //横幅
    height : number = 0 //縦幅
    rotate : number = 0 //作成時の向き
    rotatedWidth : number = 0 //回転後の横幅
    rotatedHeight : number = 0 //回転後の縦幅
    isMobile : boolean = false //?
    horizontal : boolean = false;
    color : string = ""
    isSns : boolean = false;
    recentUsedAt : number = 0;

    //旧テンプレートの詳細(なくなった)
    // detail : Detail = new Detail();
}
